import React from 'react';
import { Loading, Icon } from '@/components';
import { i18n, Zen3d } from '@/utils';
import styles from './style.less';

export interface PreviewProps {
  renderHeader: React.ReactNode;
  pathFBX: string;
  zen3d?: Zen3d;
  uploading: boolean;
  source?: string;
  onConfirm: () => void;
}

interface PreviewState {
  loading: boolean;
  autoRotate: boolean;
}

class Preview extends React.Component<PreviewProps, PreviewState> {
  private _element: HTMLElement | null | undefined;

  constructor(props: PreviewProps) {
    super(props);
    this.state = {
      loading: true,
      autoRotate: true
    }
  }

  async componentWillReceiveProps(nextProps: PreviewProps) {
    if (nextProps.source) {
      const { zen3d, pathFBX, source } = nextProps;
      if (this._element && zen3d && source) {
        zen3d.render(this._element, pathFBX);
        await zen3d.updateTexture(source);
        this.setState({
          loading: false
        });
      }
    }
  }

  /** 开始/暂停控制 */
  handleControl = () => {
    const { autoRotate } = this.state;
    const { zen3d } = this.props;
    if (zen3d) {
      if (autoRotate) { // 暂停
        zen3d.setAutoRotate(false);
        this.setState({
          autoRotate: false
        });
      } else {
        zen3d.setAutoRotate(true);
        this.setState({
          autoRotate: true
        });
      }
    }
  }

  render() {
    const { renderHeader, uploading, onConfirm } = this.props;
    const { loading, autoRotate } = this.state;
    
    return (
      <div className={styles.preview}>
        {renderHeader}
        <div className={styles.previewContent}>
          {loading &&
            <div className={styles.loadingWrap}>
              <Loading.Threed />
              <span>{i18n.format('modules.global.loading')}</span>
            </div>
          }
          <div ref={_ => this._element = _} className={styles.previewContentThreed} />
          {!loading && 
            <div className={styles.previewContentControl} onClick={this.handleControl}>
              <Icon type={autoRotate ? 'pause-circle' : 'play-circle'} size={30} color="#898789" />
            </div>
          }
        </div>
        {!loading && 
          <div className={styles.previewFooter} onClick={onConfirm}>
            {i18n.format('modules.global.confirm.design')}
          </div>
        }
        {uploading && 
          <div className={styles.previewUpload}>
            <div className={styles.previewUploadProgress} />
            <div className={styles.previewUploadFooter}>
              <span>{i18n.format('modules.global.preview.confirm')}</span>
            </div>
          </div>
        }
      </div>
    );
  }
}

export default Preview;